import { IActivityBase } from '../../models/activities';
import { ISpotBase } from '../../models/spots';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateActivityAvatarProps {
  activityId: string;
  avatarData: FormData;
}

export interface IUpdatedActivityAvatar extends IActivityBase {
  spot: ISpotBase;
}

export const updateActivityAvatarsService = async ({
  avatarData,
  activityId,
}: IUpdateActivityAvatarProps): Promise<IUpdatedActivityAvatar> => {
  const { data } = await jhsfBookingsApi.patch<IUpdatedActivityAvatar>(
    `/avatars/activities/${activityId}`,
    avatarData,
  );

  return data;
};
